import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

interface Props {
  sport?: string;
  variant?: "default" | "compact";
}

const InlineCTA = ({ sport, variant = "default" }: Props) => {
  const heading = sport
    ? `Try VIZ free for ${sport.charAt(0).toUpperCase() + sport.slice(1)}`
    : "Train your mind like an elite athlete";

  if (variant === "compact") {
    return (
      <div className="my-10 not-prose rounded-xl border border-primary/30 bg-primary/5 p-5 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <Sparkles className="w-5 h-5 text-primary flex-shrink-0" />
          <p className="text-sm text-foreground m-0">{heading}. 7-day free trial.</p>
        </div>
        <Button variant="hero" size="sm" asChild>
          <Link to="/signup">
            Start free <ArrowRight className="w-4 h-4 ml-1" />
          </Link>
        </Button>
      </div>
    );
  }

  return (
    <aside className="my-12 not-prose rounded-2xl border border-primary/30 gradient-card p-6 md:p-8 shadow-card relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-primary/30 blur-3xl" />
      </div>
      <div className="relative z-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium tracking-wide mb-4">
          <Sparkles className="w-3.5 h-3.5" /> VIZ
        </div>
        <h3 className="font-display text-2xl md:text-3xl font-bold mb-2">{heading}</h3>
        <p className="text-muted-foreground mb-6 max-w-lg">
          Personalized guided visualizations built on the PETTLEP sports-science framework.
          AI-generated. Premium audio. Made for athletes.
        </p>
        <div className="flex flex-wrap gap-3">
          <Button variant="hero" size="lg" asChild>
            <Link to="/signup">
              Start your free trial <ArrowRight className="ml-1 w-4 h-4" />
            </Link>
          </Button>
          <Button variant="hero-outline" size="lg" asChild>
            <Link to="/#how-it-works">See how it works</Link>
          </Button>
        </div>
        <p className="text-xs text-muted-foreground mt-4">
          7-day free trial · Cancel anytime · No commitment
        </p>
      </div>
    </aside>
  );
};

export default InlineCTA;
